module.exports = __webpack_public_path__ + "img/goods_list_bk1.9a530977.png";